/**
 * Device detection utilities
 */

/**
 * Detects if the user is on an iOS device (iPhone, iPad, iPod)
 * @returns true if iOS device, false otherwise
 */
export const isIOS = (): boolean => {
  // Check for iOS devices including iPad on iOS 13+
  return /iPad|iPhone|iPod/.test(navigator.userAgent) || 
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
};

/**
 * Detects if the user is on an Android device
 * @returns true if Android device, false otherwise
 */
export const isAndroid = (): boolean => {
  return /Android/.test(navigator.userAgent);
};

/**
 * Detects if the user is on any mobile device
 * @returns true if mobile device, false otherwise
 */
export const isMobileDevice = (): boolean => {
  return isIOS() || isAndroid() || /webOS|BlackBerry|Windows Phone/i.test(navigator.userAgent);
};